var React = require('react');

function StairsUpInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M60 60H4","fill":"#FFE0E0","opacity":".654","key":0}),React.createElement("path",{"d":"M0 0h64v64H0z","key":1}),React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","d":"M5 59V47h13V35h14V23h13V11h14","key":2}),React.createElement("path",{"d":"M21 13L11 23","stroke":"currentColor","strokeWidth":"2","strokeLinejoin":"round","key":3}),React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","d":"M13 13h8v8","key":4})]));
}

StairsUpInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = StairsUpInline;

StairsUpInline.default = StairsUpInline;
